export enum ColorMenuType {
  Text = 'text',
  Highlight = 'highlight',
}
